import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import Fuse from 'fuse.js'; 
import { getRecaptchaToken } from './utils/recaptcha.js';

import * as ValidatorModule from 'validatorjs';

import en from 'validatorjs/src/lang/en';

const Validator = ValidatorModule.default || ValidatorModule;

Validator.setMessages('en', en);

Alpine.plugin(intersect);

import WebViewer from '@pdftron/pdfjs-express';


// Optional: initialize Swiper if needed globally
window.addEventListener('DOMContentLoaded', () => {

  const applyFigureHeights = () => {
    if (window.innerWidth <= 782) return;

    const columnBlocks = document.querySelectorAll('.wp-block-columns-is-layout-flex');
    const teaserBlocks = document.querySelectorAll('.teaser-cards');

    // Handle wp-block-columns-is-layout-flex
    columnBlocks.forEach(block => {
      const figures = block.querySelectorAll('figure');
      if (figures.length === 0) return;

      let maxHeight = 0;

      figures.forEach(figure => {
        figure.style.height = 'auto';
        const height = figure.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      figures.forEach(figure => {
        figure.style.height = `${maxHeight}px`;
        figure.classList.add('!flex', 'items-center', 'justify-center');
      });
    });

    // Handle teaser-cards
   // Small debounce helper
  const debounce = (fn, wait = 100) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  function equalizeHeadings(block) {
    const headings = block.querySelectorAll('h3');
    if (!headings.length) return;

    let maxHeadingHeight = 0;
    headings.forEach(h3 => {
      h3.style.height = 'auto';
      const h = h3.offsetHeight;
      if (h > maxHeadingHeight) maxHeadingHeight = h;
    });

    headings.forEach(h3 => {
      h3.style.height = `${maxHeadingHeight}px`;
    });
  }

  function equalizeFigures(block) {
    const figures = block.querySelectorAll('figure');
    if (!figures.length) return;

    let maxHeight = 0;
    figures.forEach(figure => {
      figure.style.height = 'auto';
      const h = figure.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    figures.forEach(figure => {
      figure.style.height = `${maxHeight}px`;
      figure.classList.add('!flex', 'items-center', 'justify-center');
    });
  }

  // Wait for all <img> in the figures to finish loading, then equalize
  function whenFigureImagesLoaded(block, callback) {
    const imgs = block.querySelectorAll('figure img');
    if (!imgs.length) {
      callback();
      return;
    }

    let remaining = 0;

    imgs.forEach(img => {
      if (img.complete && img.naturalWidth > 0) {
        // already loaded
        return;
      }
      remaining++;
      const done = () => {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        remaining--;
        if (remaining === 0) callback();
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done); // still proceed on error
    });

    if (remaining === 0) callback();
  }

  const run = () => {
    teaserBlocks.forEach(block => {
      // 1) Equalize headings immediately
      equalizeHeadings(block);

      // 2) After images inside figures load, equalize figures
      whenFigureImagesLoaded(block, () => {
        equalizeFigures(block);

        // If this sits inside a Swiper with autoHeight
        // and you want the wrapper to adapt:
        // if (window.mySwiper) window.mySwiper.updateAutoHeight();
      });
    });
  };

  const runDebounced = debounce(run, 100);

  // initial
  run();
  // re-run on resize (layouts/line breaks change)
  window.addEventListener('resize', runDebounced);

};

// Debounce to avoid running repeatedly on resize
let resizeTimeout;
const handleResize = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    // Reset all heights before recalculating
    document.querySelectorAll('.wp-block-columns-is-layout-flex figure').forEach(figure => {
      figure.style.height = 'auto';
    });
    document.querySelectorAll('.teaser-cards img, .teaser-cards h3').forEach(el => {
      el.style.height = 'auto';
    });

    applyFigureHeights();
  }, 150);
};

// Initial run
applyFigureHeights();

// Re-run on resize
window.addEventListener('resize', handleResize);



// Debounced recalc helper
const debounce = (fn, wait = 100) => { let t; return (...a)=>{clearTimeout(t); t=setTimeout(()=>fn(...a), wait);} };
const recalcEqualHeights = debounce(() => {
  // Reset heights before recalculating
  document.querySelectorAll('.wp-block-columns-is-layout-flex figure').forEach(f => f.style.height = 'auto');
  document.querySelectorAll('.teaser-cards img, .teaser-cards h3').forEach(el => el.style.height = 'auto');
  applyFigureHeights();
}, 75);

// Observe lazyload changes
if ('MutationObserver' in window) {
  const mo = new MutationObserver(mutations => {
    let needs = false;
    for (const m of mutations) {
      const el = m.target;
      if (
        el &&
        el.tagName === 'IMG' &&
        (el.classList.contains('lazyloaded') || el.getAttribute('data-ll-status') === 'loaded')
      ) {
        if (el.closest('.teaser-cards, .wp-block-columns-is-layout-flex')) {
          needs = true;
        }
      }
    }
    if (needs) recalcEqualHeights();
  });

  mo.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'data-ll-status', 'src', 'srcset']
  });
}


  new Swiper('.hero-swiper', {
    autoHeight: true, // <-- This makes the height adjust per slide
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next-card',
      prevEl: '.swiper-button-prev-card',
    },
    autoplay: { delay: 4000 },
  });


  const teamSlider = document.querySelectorAll('.team-swiper');
  const teamSwiper = [];

  for (let i = 0; i < teamSlider.length; i++) {
    const slider = teamSlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-team');
      const prevBtn = parent.querySelector('.swiper-button-prev-team');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-team-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-team-' + i);

      teamSwiper[i] = new Swiper('.swiper-container-' + i, {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: slides,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar-" + i,
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-team-" + i,
          prevEl: ".swiper-button-prev-team-" + i,
        },
      });
    }
  }

  const quoteSlider = document.querySelectorAll('.quote-swiper');
  const quoteSwiper = [];

  for (let i = 0; i < quoteSlider.length; i++) {
    const slider = quoteSlider[i];

    const slides = slider.getAttribute('data-slides');

    slider.classList.add('swiper-container-' + i);

    const scrollbar = slider.querySelector('.swiper-scrollbar');
    if (scrollbar) scrollbar.classList.add('swiper-scrollbar-' + i);

    const parent = slider.parentElement;
    if (parent) {
      const nextBtn = parent.querySelector('.swiper-button-next-quote');
      const prevBtn = parent.querySelector('.swiper-button-prev-quote');
      if (nextBtn) nextBtn.classList.add('swiper-button-next-quote-' + i);
      if (prevBtn) prevBtn.classList.add('swiper-button-prev-quote-' + i);

      quoteSwiper[i] = new Swiper('.swiper-container-' + i, {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
            mousewheel: true,
          }
        },
        navigation: {
          nextEl: ".swiper-button-next-quote-" + i,
          prevEl: ".swiper-button-prev-quote-" + i,
        },
      });
    }
  }

  document.querySelectorAll(".gform_wrapper form").forEach(form => {

    const handler = function () {
      const formId = form.querySelector('[name="form_id"]')?.value || form.id || 'unknown';
        
      const formName = form.dataset.formName || 'Gravity Form';

      window.dataLayer.push({
        event: "form_started",
        form_name: formName,
        form_id: formId
      });

      form.removeEventListener("focusin", handler);
    };

    form.addEventListener("focusin", handler);
  });

  window.gformFormData = window.gformFormData || {};

  document.addEventListener('gform/post_render', (event) => {
    // console.log('hi');
      // Store form data globally
      

      const formId = event.detail.formId;
      const form = document.querySelector(`#gform_${formId}`);
      const formName = form?.dataset.formName || 'Gravity Form';

      // Check if the form has validation errors
      const errorFields = form?.querySelectorAll('.gfield.gfield_error') || [];
      if (errorFields.length > 0) {
        const errors = Array.from(errorFields).map(field => {
          const label = field.querySelector('label')?.textContent?.trim() || 'Unknown field';
          const message = field.querySelector('.gfield_description, .validation_message')?.textContent?.trim() || 'Error';
          return `${label}: ${message}`;
        });

        window.dataLayer.push({
          event: "form_invalid",
          form_name: formName,
          form_id: formId,
          form_errors: errors
        });
      }
  });

  jQuery(document).bind("gform_confirmation_loaded", function(event, formId) {

      event.preventDefault();
      // console.log(formId);
      // const formInfo = window.gformFormData[formId] || {};
      // const formName = formInfo.formName || 'Gravity Form';
      // const marketingOptIn = formInfo.marketingOptIn || false;

      fetch('/api/get-form-name', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formId)
        })
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        name = data.title;
        // console.log(name);
        let marketingOptIn = null;

        for (const field of data.fields) {
          if (field.adminLabel === 'marketing_opt_in') {
            marketingOptIn = true;
            break; // Stop once found
          }
        }

        window.dataLayer = window.dataLayer || [];
         window.dataLayer.push({
           event: "form_complete",
          form_name: name,
          form_id: formId,
          marketing_opt_in: marketingOptIn

         });
        
      })
      .catch(() => {
      })

      
    });

  // Track login form start
  (function () {
      const form = document.getElementById('loginform');
      if (!form) return; // Exit if login form doesn't exist

      let formStarted = false;

      function fireFormStartEvent() {
        if (formStarted) return;
        formStarted = true;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_started",
          form_name: "login",
          form_id: "login"
        });
      }

      // Trigger on first interaction (typing or focusing)
      form.addEventListener('input', fireFormStartEvent, { once: true });
      form.addEventListener('focusin', fireFormStartEvent, { once: true });
    })();

  document.body.addEventListener('click', function (event) {
    // event.preventDefault();
    const trackedClasses = [
      'button',
      'button-orange',
      'button-blue',
      'button-outline',
      'resource-teaser-download',
      'resource-teaser-view',
      'track-button',
      'wp-block-button__link',
      'download-part-menu'
    ];

    
      const el = event.target.closest(trackedClasses.map(cls => `.${cls}`).join(', '));
      if (!el) return;

      // Get the destination URL (for <a> or <button data-url>)
      const url = el.tagName === 'A' ? el.href : el.dataset.url || null;

      // if (el.tagName === 'A' && url) {
      //   event.preventDefault();
      //   setTimeout(() => {
      //     window.location.href = url;
      //   }, 200);
      // }

      // If it's an <a> tag with target="_blank", don't override the default behavior
      if (el.tagName === 'A' && url && el.target !== '_blank') {
        event.preventDefault();
        setTimeout(() => {
          window.location.href = url;
        }, 200);
      }

      // Try to get the component/section name from a parent block
      const block =
      el.dataset['component'] ||
      el.closest('[id]')?.id ||
      'unknown';

      const label = el.textContent.trim();

    //   console.log("📦 Pushing to dataLayer:", {
    //   event: 'click_button',
    //   component_block: block,
    //   link_url: url,
    //   button_text: label
    // });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_button',
        component_block: block,
        link_url: url,
        button_text: label
      });

      
      // Optional: debug
      // console.log('✅ click_button event:', { component_block: block, link_url: url, button_text: label });
    });

});

Alpine.data('shareComponent', (data) => ({
    copied: false,
    copyUrl(passedURL) {
      let url;
      if(passedURL){
        // console.log(passedURL);
        url = passedURL;
      } else {
        url = window.location.href;
        // console.log(url);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => this.showCopied())
          .catch(() => this.fallbackCopy(url));
      } else {
        this.fallbackCopy(url);
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.showCopied();
      } catch (err) {
        alert('Copy failed. Please copy manually.');
      }
      document.body.removeChild(input);
    },
    showCopied() {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    }
}));

Alpine.data('countComponent', ({ start = 0, end = 100, duration = 2000 } = {}) => ({
    display: start,
    startValue: start,
    endValue: end,
    duration: duration,
    startTime: null,
    
    start() {
      this.startTime = null;
      const step = (timestamp) => {
        if (!this.startTime) this.startTime = timestamp;
        const progress = timestamp - this.startTime;
        const value = Math.min(
          this.startValue + (progress / this.duration) * (this.endValue - this.startValue),
          this.endValue
        );
        this.display = Math.floor(value);
        if (progress < this.duration) {
          requestAnimationFrame(step);
        } else {
          this.display = this.endValue;
        }
      };
      requestAnimationFrame(step);
    }
  }));


Alpine.data('videoPlayer', (youtube_id) => ({
  isPlaying: false,
  youtube_id: youtube_id,
  player: null,
  playerReady: false,
  videoTitle: '',
  progressInterval: null,
  lastReportedPercent: 0,
  apiLoaded: false,
  hasStarted: false,

  init() {
    this.loadYouTubeAPI().then(() => {
      this.apiLoaded = true;
    });
  },

  loadYouTubeAPI() {
    return new Promise((resolve) => {
      if (window.YT && typeof YT.Player !== 'undefined') {
        return resolve();
      }

      // If already loading, wait for it
      if (window._ytApiLoading) {
        const checkInterval = setInterval(() => {
          if (window.YT && typeof YT.Player !== 'undefined') {
            clearInterval(checkInterval);
            resolve();
          }
        }, 50);
        return;
      }

      // Mark that we're loading the API
      window._ytApiLoading = true;

      // Load the script
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // YouTube API will call this when ready
      window.onYouTubeIframeAPIReady = () => {
        resolve();
      };
    });
  },

playVideo() {
  if (!this.apiLoaded) {
    console.warn('YouTube API not yet ready');
    return;
  }

  this.isPlaying = true;

  const playerId = 'yt-player-' + this.youtube_id;
  this.$refs.iframeContainer.innerHTML = '';

  const div = document.createElement('div');
  div.id = playerId;
  this.$refs.iframeContainer.appendChild(div);

  this.player = new YT.Player(playerId, {
    videoId: this.youtube_id,
    playerVars: {
      modestbranding: 1,
      rel: 0,
    },
    events: {
      onReady: (event) => {
        const tryPlay = () => {
          try {
            // Will throw if player isn't fully initialized yet
            const state = event.target.getPlayerState();
            // console.log('Player state:', state);

            // Now it's safe to call playVideo
            event.target.playVideo();
            this.onPlayerReady(event);
          } catch (err) {
            // Wait and try again
            console.warn('Player not fully initialized, retrying...');
            setTimeout(tryPlay, 50);
          }
        };

        tryPlay();
      },

      // onStateChange: this.onPlayerStateChange.bind(this)
    }
  });
},


  onPlayerReady(event) {
    const iframeEl = event.target.getIframe();
    iframeEl.classList.add('aspect-video', 'w-full', 'h-auto');

    this.playerReady = true;
    // this.videoTitle = event.target.getVideoData().title || 'Unknown';
  },

  onPlayerStateChange(event) {
    const title = this.videoTitle || 'Unknown';
    const url = `https://www.youtube.com/watch?v=${this.youtube_id}`;

    switch (event.data) {
      case YT.PlayerState.PLAYING:
        if (this.hasStarted == false) {
          this.pushToDataLayer('video_start', title, url, 0);
          this.hasStarted = true;
        }
        this.startTrackingProgress(title, url);
        break;

      case YT.PlayerState.PAUSED:
        this.stopTrackingProgress();
        break;

      case YT.PlayerState.ENDED:
        this.pushToDataLayer('video_complete', title, url, 100);
        this.stopTrackingProgress();
        break;
    }
  },

  startTrackingProgress(title, url) {
    if (this.progressInterval || !this.playerReady) return;

    this.progressInterval = setInterval(() => {

      const duration = this.player?.getDuration?.();
      const currentTime = this.player?.getCurrentTime?.();

      // console.log(duration);
      // console.log(currentTime);

      if (!duration || !currentTime || isNaN(duration) || isNaN(currentTime)) return;

      const percent = Math.floor((currentTime / duration) * 100);
      const milestones = [25, 50, 75];

      for (let m of milestones) {
        if (percent >= m && this.lastReportedPercent < m) {
          this.pushToDataLayer('video_progress', title, url, m);
          this.lastReportedPercent = m;
        }
      }
    }, 1000);
  },

  stopTrackingProgress() {
    clearInterval(this.progressInterval);
    this.progressInterval = null;
  },

  pushToDataLayer(eventName, title, url, percent) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      video_title: title,
      video_url: url,
      video_provider: "YouTube",
      progress_percent: percent
    });
  }
}));




// document.addEventListener('alpine:init', () => {
//   alert('test');

document.addEventListener('alpine:init', () => {

  // console.log('109');
  // console.log(typeof wp);

  if (typeof wp !== 'undefined' && wp.data) {
        // Running inside editor → skip Alpine or disable
        return;
    }

  Alpine.store('globalState', {
    resourceURL: false,
    resourceID: false,
    resourceTitle: false,
    resourceFile: false,
    resourceFileName: false,
    resourceCategory: false,
    resourceBundle: false,
    downloadID: false,
    accountCreated: false,
    ratingModalOpen: false, 
    setResourceURL(value) {
      this.resourceURL = value;
    },
    setResourceID(value) {
      this.resourceID = value;
    },
    setResourceTitle(value) {
      this.resourceTitle = value;
    },
    setResourceFile(value) {
      this.resourceFile = value;
    },
    setResourceFileName(value) {
      this.resourceFileName = value;
    },
    setResourceCategory(value) {
      this.resourceCategory = value;
    },
    setResourceBundle(value) {
      this.resourceBundle = value;
    },
    setDownloadID(value) {
      this.downloadID = value;
    },
    setAccountCreated() {
      this.accountCreated = !this.accountCreated;
    },
    setRatingModalOpen(status) { 
      this.ratingModalOpen = status; 
    }
  });

  Alpine.data('tabComponent', (data) => ({
    selectedTab: data.initialTab,
    resourceName: data.resourceName,
    tabTitleMap: data.tabTitleMap || {},

    selectTab(tabTitle) {
      this.selectedTab = tabTitle;

      // GTM Tracking
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "tab_click",
        component_block: this.resourceName + " download tabs",
        tab_text: decodeURIComponent(tabTitle)
      });
    },

    isSelected(tabTitle) {
      return this.selectedTab === tabTitle;
    },

    get selectedTabLabel() {
      return this.tabTitleMap[this.selectedTab] || '';
    }
  }));

  Alpine.data('acfMap', (data) => ({
  map: null,
  markers: [],
  zoom: data?.zoom ?? 16,

  init() {
    // wait for Google (keep whatever readiness logic you had)
    if (!(window.google && google.maps)) {
      const onReady = () => { window.removeEventListener('gmaps:ready', onReady); this.init(); };
      window.addEventListener('gmaps:ready', onReady, { once: true });
      return;
    }

    // 1) CACHE marker elements *before* creating the map (creating the map nukes children)
    const markerEls = Array.from(this.$el.querySelectorAll('.marker'));
    const parsed = markerEls
      .map((el, i) => {
        const lat = parseFloat(el.dataset.lat);
        const lng = parseFloat(el.dataset.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          console.warn(`[acfMap] Skipping marker #${i}: invalid lat/lng`, el.dataset);
          return null;
        }
        return { lat, lng, html: el.innerHTML.trim() };
      })
      .filter(Boolean);

    // 2) Create the map (this clears the container’s innerHTML)
    this.map = new google.maps.Map(this.$el, {
      zoom: Number(this.$el.dataset.zoom || this.zoom),
      center: parsed[0] ?? { lat: 51.5074, lng: -0.1278 }, // fallback center
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    // 3) Add markers from the cached data
    this.markers = [];
    parsed.forEach(({ lat, lng, html }) => {
      const marker = new google.maps.Marker({ position: { lat, lng }, map: this.map });
      if (html) {
        const iw = new google.maps.InfoWindow({ content: html });
        marker.addListener('click', () => iw.open(this.map, marker));
      }
      this.markers.push(marker);
    });

    // 4) Center/fit
    if (this.markers.length === 0) {
      this.map.setCenter(parsed[0] ?? { lat: 51.5074, lng: -0.1278 });
      this.map.setZoom(Number(this.$el.dataset.zoom || this.zoom));
    } else if (this.markers.length === 1) {
      this.map.setCenter(this.markers[0].getPosition());
      this.map.setZoom(Number(this.$el.dataset.zoom || this.zoom));
    } else {
      const bounds = new google.maps.LatLngBounds();
      this.markers.forEach(m => bounds.extend(m.getPosition()));
      this.map.fitBounds(bounds);
    }
  },
}));
  
});

// Alpine.data('searchTaxonomies', (data) => ({
//   contexts: data.contexts,
//   topics: data.topics,
//   bible_books: data.bible_books
// }));

Alpine.data('searchForm', (data) => ({
  formData: {
    s: data.searchTerm,  // ← make sure this exists!
    'content_type[]': data.currentContentTypes,
    'context[]': data.currentContexts,
    'topic[]': data.currentTopics,
    'bible-book[]': data.currentBibleBooks
  },
  ajaxformData: {
    s: data.searchTerm,  // ← make sure this exists!
    'content_type': data.currentContentTypes,
    'context': data.currentContexts,
    'topic': data.currentTopics,
    'bible-book': data.currentBibleBooks
  },
  content_types: data.content_types,
  contexts: data.contexts,
  topics: data.topics,
  bible_books: data.bible_books,
  location: data.location,
  dropdowns: [
    { key: 'content_types', label: data.content_types_name, inputName: 'content_type[]' },
    { key: 'contexts', label: data.resource_categories_name, inputName: 'context[]' },
    { key: 'topics', label: data.resource_topics_name, inputName: 'topic[]' },
    { key: 'bible_books', label: data.resource_bible_books_name, inputName: 'bible-book[]' }
  ],
  loading: false,
  alpineActive: false,
  pagination: false,
  search(){
    // console.log(this.dropdowns);
    // console.log('searching');
    // // console.log(this.formData.s);
    // console.log(this.formData['context[]']);
    // console.log(this.formData['topic[]']);

    this.loading = true;
    // Proceed with submission
    fetch('/ajax/search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.formData)
    })
    .then(response => response.json())
    .then(data => {

      // console.log(data);
      this.searchResults = data.posts;          // store posts array
      this.pagination = data.pagination;        // store pagination object
      this.loading = false;
      this.alpineActive = true;
      //NOW TO UPDATE THE PAGE
      
    })
    .catch(() => {
      this.message = 'Ooops! Something went wrong!';
    });

    // GTM tracking
    this.gtmTrack();
  },

  gtmTrack(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "site_search", //CONSTANT
      search_location: this.location, //Dynamic based on location of search - Menu OR Onpage
      search_term: this.formData.s, //Dynamic based on the filter option choosen 
      context_filter: this.formData['context[]'], //Dynamic based on the filter option choosen
      topic_filter: this.formData['topic[]'], //Dynamic based on the filter option choosen
      bible_book_filter: this.formData['bible-book[]'], //Dynamic based on the filter option  choosen
    });
  },

  submit(){
    this.gtmTrack();
  },

  getQueryString() {
  const params = new URLSearchParams();

  for (const key in this.formData) {
    const value = this.formData[key];

    if (Array.isArray(value)) {
      value.forEach(val => params.append(key, val));
    } else if (key === 's') {
      // Always include 's', even if it's an empty string
      params.append(key, value ?? '');
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  }

  return params.toString();
}
}));

Alpine.data('podcastSearchForm', (data) => {
    // 1. Now you can log the data safely
    console.log('Received data:', data);

    // 2. Explicitly return the object
    return {
      formData: {
        s: data.searchTerm,  // ← make sure this exists!
        'podcast[]': data.podcast,
        ajax: true
      },
      podcasts: data.podcasts,
      dropdowns: [
        { key: 'podcasts', label: 'Podcasts', inputName: 'podcast[]' }
      ],
      loading: false,
      alpineActive: false,
      pagination: false,
      searchResults: false,
      search(e){
        console.log('dropdowns');
        console.log(this.podcasts);
        console.log('searching');
        console.log(this.formData);
        // console.log(this.formData['context[]']);
        // console.log(this.formData['topic[]']);

        e.preventDefault();

        this.loading = true;
        // Proceed with submission
        fetch('/resources/podcasts/search', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.formData)
        })
        .then(response => response.json())
        .then(data => {

          console.log(data);
          this.searchResults = data.posts;          // store posts array
          this.pagination = data.pagination;        // store pagination object
          this.loading = false;
          this.alpineActive = true;
          //NOW TO UPDATE THE PAGE
          
        })
        .catch(() => {
          this.message = 'Ooops! Something went wrong!';
        });

        // GTM tracking
        // this.gtmTrack();
      },

      // gtmTrack(){
      //   window.dataLayer = window.dataLayer || [];
      //   window.dataLayer.push({
      //     event: "site_search", //CONSTANT
      //     search_location: this.location, //Dynamic based on location of search - Menu OR Onpage
      //     search_term: this.formData.s, //Dynamic based on the filter option choosen 
      //     context_filter: this.formData['context[]'], //Dynamic based on the filter option choosen
      //     topic_filter: this.formData['topic[]'], //Dynamic based on the filter option choosen
      //     bible_book_filter: this.formData['bible-book[]'], //Dynamic based on the filter option  choosen
      //   });
      // },

      submit(){
        // this.gtmTrack();
      },

      reset(){
        console.log("TEST");
        this.formData.s = '';
        this.alpineActive = false;
        this.pagination = false;
      },

      getQueryString() {
        const params = new URLSearchParams();

        for (const key in this.formData) {
          const value = this.formData[key];

          if (Array.isArray(value)) {
            value.forEach(val => params.append(key, val));
          } else if (key === 's') {
            // Always include 's', even if it's an empty string
            params.append(key, value ?? '');
          } else if (value !== undefined && value !== null && value !== '') {
            params.append(key, value);
          }
        }

        return params.toString();
      }
    }
});


Alpine.data('resetPassword', (data) => ({
  formData: {
    password: '',
    passwordConf: '',
  },
  error: '',
  password: { errorMessage: "", blurred: false },
  passwordConf: { errorMessage: "", blurred: false },
  loading: false,
  inputElements: [],
  
  showLoader() {
    this.loading = true;
  },

  hideLoader() {
    this.loading = false;
  },

  change(event) {
    const ele = event.target;

      if (ele.type === 'checkbox' || ele.type === 'radio') return;


    if (ele.className !== 'button m-auto') {
      this[ele.name].blurred = true;
      this[ele.name].errorMessage = '';
      this.validateField(ele.name, ele.value, ele.dataset.rules);
    }
  },

  input(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
  },

  validateField(name, value, rulesString) {

   const rules = { [name]: rulesString };

   // console.log(name, value);


    // Include password in data if validating passwordConf
    const data = {
      [name]: value,
      ...(name === 'passwordConf' ? { password: this.formData.password } : {})
    };

    const validation = new Validator(data, rules);

    if (validation.fails()) {
      const messages = validation.errors.get(name);
      const messages_replaced = messages.map(msg =>
        msg.replace(/passwordConf/g, 'password confirmation')
      );
      this[name].errorMessage = messages_replaced ? messages_replaced[0] : 'Invalid input';
    }
  },

  submit(event) {

    // console.log(this.inputElements);
    this.showLoader();
    // this.inputElements = [...this.$el.querySelectorAll("input[data-rules]")];

    let allValid = true;

    // Use querySelectorAll *only* to grab rules (you could even cache this)
    const inputsWithRules = [...this.$el.querySelectorAll("input[data-rules], select[data-rules], textarea[data-rules]")];
    const form = event?.target || this.$el; // the <form>
    
    // Build a quick map of rules
    const rulesMap = {};
    inputsWithRules.forEach(input => {
      rulesMap[input.name] = input.dataset.rules;
    });
    // console.log(this.formData);
    // console.log("633");
    // Loop through formData to validate each field
    for (const fieldName in this.formData) {

      const value = this.formData[fieldName];
      const rules = rulesMap[fieldName] || ''; // fallback to no rules if missing

      // ✅ Skip fields with no rules
      if (!rules || rules.trim() === '') continue;

      // console.log(fieldName, value);
      this.validateField(fieldName, value, rules);

      if (this[fieldName]?.errorMessage) {
        allValid = false;
        this.currentErrors.push(this[fieldName].errorMessage);

        const input = inputsWithRules.find(el => el.name === fieldName);
        if (input) input.classList.add('invalid');
      }

    }

    if (!allValid) {
      event.preventDefault();
      this.hideLoader();
      return;
    }

    // ✅ valid: actually submit despite @submit.prevent
    // Disable the submit button to avoid double posts
    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (btn) btn.disabled = true;

    // Use the form’s native submit
    form.submit();
  },

}));

Alpine.data('createAccount', (data) => ({
  formData: {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    passwordConf: '',
    role: [],
    church_name: '',
    mailinglist: '',
    beacon_organisation_id: ''
  },
  allOrgs: [], 
  suggestions: [],
  open: false,
  spellingSuggestion: null,
  
  // 1. A compact dictionary of common words used in organisation and church names
  spellingDictionary: [
    'church', 'community', 'fellowship', 'chapel', 'ministries', 'cathedral', 
    'parish', 'baptist', 'methodist', 'anglican', 'presbyterian', 'evangelical', 
    'center', 'centre', 'association', 'foundation', 'trust', 'group', 'st'
  ],
  dictionaryFuse: null,

  resourceURL: '',
  resourceID: '',
  error: '',
  first_name: { errorMessage: "", blurred: false },
  last_name: { errorMessage: "", blurred: false },
  email: { errorMessage: "", blurred: false },
  password: { errorMessage: "", blurred: false },
  passwordConf: { errorMessage: "", blurred: false },
  role: { errorMessage: "", blurred: false },
  church_name: { errorMessage: "", blurred: false },
  mailinglist: { errorMessage: "", blurred: false },
  loading: false,
  inputElements: [],
  formStarted: false,
  formId: data.id || 'signUp',
  formName: data.formName || 'Create Account',
  currentErrors: [],
  recaptchaAction: 'signup',

  async init() {
    try {
        // Fetch the compiled JSON layout dictionary file generated by your server cron script
        const response = await fetch('/app/uploads/organisations.json'); // Adjust route if needed
        if (response.ok) {
            this.allOrgs = await response.json();
            
            this.dictionaryFuse = new Fuse(this.spellingDictionary, {
                threshold: 0.4, // Sensitivity tuning for spelling errors
                distance: 10
            });
        }
    } catch (e) {
        console.error("Could not seed organisation autocomplete engine:", e);
    }
  },

  search() {
      this.spellingSuggestion = null; 

      if (this.formData.church_name.length < 2) {
          this.suggestions = [];
          this.open = false;
          return;
      }

      // The dropdown still uses the real organization list for matching selections
      if (this.allOrgs.length > 0) {
          const rawMatches = this.allOrgs.filter(org => 
              org.n.toLowerCase().includes(this.formData.church_name.toLowerCase())
          );
          this.suggestions = rawMatches.slice(0, 5);
      }
      
      this.open = this.suggestions.length > 0;
  },

  // 3. New Generic Spell Checking Logic
  checkSpelling() {
      this.open = false; 
      this.spellingSuggestion = null;

      if (!this.dictionaryFuse || this.formData.church_name.length < 3) return;

      // Break what they typed into individual lowercase words (e.g., ["st", "johns", "churhc"])
      const inputWords = this.formData.church_name.toLowerCase().replace(/[^a-z0-9\s]/g, '').split(/\s+/);

      for (const word of inputWords) {
          if (word.length < 3) continue;

          // Check if this exact word exists in our safe dictionary list
          const isRealWord = this.spellingDictionary.includes(word);

          if (!isRealWord) {
              // Run a fuzzy search on just this single input word against our dictionary items
              const dictionaryMatches = this.dictionaryFuse.search(word);

              if (dictionaryMatches.length > 0) {
                  const bestMatch = dictionaryMatches[0].item;
                  
                  // If they typed 'churhc', bestMatch will equal 'church'. 
                  // We compile a global string replacement recommendation:
                  const regex = new RegExp(word, 'gi');
                  this.spellingSuggestion = {
                      misspelled: word,
                      corrected: bestMatch,
                      fullTextSuggestion: this.formData.church_name.replace(regex, bestMatch)
                  };
                  break; // Exit loop on the first typo caught
              }
          }
      }
  },

  nextStage() {
    this.stage = this.stage + 1;
  },

  showLoader() {
    this.loading = true;
  },

  hideLoader() {
    this.loading = false;
  },

  change(event) {
    const ele = event.target;

      if (ele.type === 'checkbox' ) return;


    if (ele.className !== 'button m-auto') {
      this[ele.name].blurred = true;
      this[ele.name].errorMessage = '';
      this.validateField(ele.name, ele.value, ele.dataset.rules);
    }
  },

  input(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
  },

  validateField(name, value, rulesString) {

   const rules = { [name]: rulesString };

   // console.log(name, value);


    // Include password in data if validating passwordConf
    const data = {
      [name]: value,
      ...(name === 'passwordConf' ? { password: this.formData.password } : {})
    };

    const validation = new Validator(data, rules);

    if (validation.fails()) {
      const messages = validation.errors.get(name);
      const messages_replaced = messages.map(msg =>
        msg.replace(/passwordConf/g, 'password confirmation')
        .replace(/mailinglist/g, 'mailing list preference')
      );
      this[name].errorMessage = messages_replaced ? messages_replaced[0] : 'Invalid input';
    }
  },

  async submit(event) {

    console.log(this.formData.role);

    // console.log(this.inputElements);
    this.showLoader();
    this.currentErrors = [];
    // this.inputElements = [...this.$el.querySelectorAll("input[data-rules]")];

    let allValid = true;

    // Use querySelectorAll *only* to grab rules (you could even cache this)
    const inputsWithRules = [...this.$el.querySelectorAll("input[data-rules], select[data-rules], textarea[data-rules]")];

    // Build a quick map of rules
    const rulesMap = {};
    inputsWithRules.forEach(input => {
      rulesMap[input.name] = input.dataset.rules;
    });
    // console.log(this.formData);
    // console.log("633");
    // Loop through formData to validate each field
    for (const fieldName in this.formData) {
      if (fieldName === 'beacon_organisation_id') continue;
      
      const value = this.formData[fieldName];
      const rules = rulesMap[fieldName] || ''; // fallback to no rules if missing

      // ✅ Skip fields with no rules
      if (!rules || rules.trim() === '') continue;

      // console.log(fieldName, value);
      this.validateField(fieldName, value, rules);

      if (this[fieldName]?.errorMessage) {
        allValid = false;
        this.currentErrors.push(this[fieldName].errorMessage);

        const input = inputsWithRules.find(el => el.name === fieldName);
        if (input) input.classList.add('invalid');
      }

    }

    if (!allValid) {
      event.preventDefault();
      this.hideLoader();
      this.errorTracking(this.currentErrors);
      return;
    }

    // === Get token via Vite helper ===
    let token;
    try {
      token = await getRecaptchaToken('6LdMcMMrAAAAANXNugAPL-hzk3rhihaadjJMaGeC', this.recaptchaAction);
      console.log("TOKEN: " + token);
    } catch (e) {
      this.hideLoader();
      this.error = 'Security check failed. Please refresh and try again.';
      return;
    }

    const payload = {
      ...this.formData,
      recaptcha_token: token,
      recaptcha_action: this.recaptchaAction
    };

    // Proceed with submission
    // fetch('/sign-up/create', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(payload)
    // })
    // .then(response => response.json())
    // .then(data => {

    //   console.log(data);

    //   if (parseInt(data, 10) === data) {

    //     // console.log("1169");

    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({ event: 'signup' });
    //     if (this.formData.newsletter === true) {
    //       window.dataLayer.push({ event: 'email-signup-create-account' });
    //     }
        
    //     Alpine.store('globalState').setAccountCreated(true);

    //     // updateResourceHistory(Alpine.store('globalState').resourceID);

    //     const link = document.createElement('a');
    //     if(Alpine.store('globalState').downloadID){
    //       updateResourceHistory(Alpine.store('globalState').resourceID);
    //       link.href = 'private/download/'+Alpine.store('globalState').downloadID;
    //     } else {
    //       link.href = '/';
    //     }
    //     // link.download = 'my-file.pdf'; // filename for download
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);

    //     this.completeFormTracking();

    //     //window.location.replace('/dashboard?new=true');
    //   } else if (data.errors?.existing_user_email) {
    //     this.hideLoader();
    //     this.error = "There's already an account with this email address.";
    //   }
    // })
    // .catch(() => {
    //   this.message = 'Ooops! Something went wrong!';
    // });
    fetch('/sign-up/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
          // This catches 400, 422, 500, etc.
          throw { status: response.status, data };
        }

        return data;
      })
      .then((data) => {
        console.log(data);
        // ✅ Success branch
        if (parseInt(data, 10) === data) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'signup' });
          if (this.formData.newsletter === true) {
            window.dataLayer.push({ event: 'email-signup-create-account' });
          }

          Alpine.store('globalState').setAccountCreated(true);

          const link = document.createElement('a');
          if (Alpine.store('globalState').downloadID) {
            updateResourceHistory(Alpine.store('globalState').resourceID);
            link.href = 'private/download/' + Alpine.store('globalState').downloadID;
          } else {
            link.href = '/';
          }
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Track download
          trackResourceDownload();

          this.completeFormTracking();
        } else if (data.errors.existing_user_login) {
          this.hideLoader();
          this.error = "There's already an account with this email address.";
        }
      })
      .catch((err) => {
        // ❌ Error branch
        this.hideLoader();

        if (err.status === 400 && err.data?.errors?.recaptcha) {
          this.error = err.data.errors.recaptcha;
          console.log(err.data.errors.detail);
        } else if (err.status === 400) {
          this.hideLoader();
          this.error = "Validation failed. Please check your details.";
        } else {
          this.hideLoader();
          this.message = 'Ooops! Something went wrong!';
        }
      });

  },

  validate(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
    if (!this[ele.name].errorMessage) {
      this.nextStage();
    }
  },

  startFormTracking() {
    if (!this.formStarted) {
      this.formStarted = true;

      const formName = "Create Account"; // You can pull from a data attribute if needed
      const formId = "signUp"; // Or dynamically from this.$el.id

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_started",
        form_name: this.formName,
        form_id: this.formId
      });
    }
  },

  completeFormTracking(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_complete",     // CONSTANT
      form_name: this.formName,
      form_id: this.formId,
      marketing_opt_in: this.formData.mailing_list, // True OR False
    });

  },

  errorTracking(error){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_invalid", // CONSTANT
      form_name: this.formName,
      form_id: this.formId,
      form_errors: error  // Dynamic array of form field errors
    });

  }
}));

Alpine.data('updateEmail', () => ({
  formData: {},
  error: '',
  email: { errorMessage: "", blurred: false },
  loading: false,
  inputElements: [],
  complete: false,

  init() {
    // No custom rules needed for basic validatorjs use
  },

  showLoader() {
    this.loading = true;
  },

  hideLoader() {
    this.loading = false;
  },

  change(event) {
    const ele = event.target;
    if (ele.className !== 'button m-auto') {
      this[ele.name].blurred = true;
      this[ele.name].errorMessage = '';
      this.validateField(ele.name, ele.value, ele.dataset.rules);
    }
  },

  input(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
  },

  validateField(name, value, rulesString) {

    console.log(name);

    const rules = { [name]: rulesString.replaceAll('|', '|') };
    const data = { [name]: value };

    const validation = new Validator(data, rules);


    if (validation.fails()) {

      const messages = validation.errors.get(name);
      const messages_replaced = messages.map(msg =>
        msg.replace(/passwordConf/g, 'password confirmation')
      );
      console.log(messages_replaced);
      this[name].errorMessage = messages_replaced ? messages_replaced[0] : 'Invalid input';
    }
  },

  submit(event) {

    this.showLoader();
    this.inputElements = [...this.$el.querySelectorAll("input[data-rules]")];

    let data = {};
    let rules = {};
    this.inputElements.forEach(input => {
      data[input.name] = input.value;
      rules[input.name] = input.dataset.rules;
    });

    // Add manual password confirmation logic
    if (data.password && data.passwordConf) {
      rules.passwordConf += `|same:password`;
    }

    const validation = new Validator(data, rules);
    if (validation.fails()) {
      event.preventDefault();
      const errors = validation.errors.all();
      for (let field in errors) {
        const input = this.inputElements.find(el => el.name === field);
        if (input) input.classList.add('invalid');
        this[field].errorMessage = errors[field][0];
      }
      this.hideLoader();
      return;
    }

    // Proceed with submission
    fetch('/account/update-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.formData)
    })
    .then(response => response.json())
    .then(data => {

      if (parseInt(data, 10) === data) {
        
         this.complete = true;

        //window.location.replace('/dashboard?new=true');
      } else if (data.errors?.existing_user_email) {
        this.hideLoader();
        this.error = "There's already an account with this email address.";
      }
    })
    .catch(() => {
      this.message = 'Ooops! Something went wrong!';
    });
  },

  validate(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
    if (!this[ele.name].errorMessage) {
      this.nextStage();
    }
  }
}));

Alpine.data('updatePassword', () => ({
  formData: {},
  error: '',
  email: { errorMessage: "", blurred: false },
  loading: false,
  inputElements: [],
  complete: false,

  init() {
    // No custom rules needed for basic validatorjs use
  },

  showLoader() {
    this.loading = true;
  },

  hideLoader() {
    this.loading = false;
  },

  change(event) {
    const ele = event.target;
    if (ele.className !== 'button m-auto') {
      this[ele.name].blurred = true;
      this[ele.name].errorMessage = '';
      this.validateField(ele.name, ele.value, ele.dataset.rules);
    }
  },

  input(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
  },

  validateField(name, value, rulesString) {

    const rules = { [name]: rulesString.replaceAll('|', '|') };
    const data = { [name]: value };

    const validation = new Validator(data, rules);


    if (validation.fails()) {

      const messages = validation.errors.get(name);
      const messages_replaced = messages.map(msg =>
        msg.replace(/passwordConf/g, 'password confirmation')
      );
      console.log(messages_replaced);
      this[name].errorMessage = messages_replaced ? messages_replaced[0] : 'Invalid input';
    }
  },

  submit(event) {

    this.showLoader();
    this.inputElements = [...this.$el.querySelectorAll("input[data-rules]")];

    let data = {};
    let rules = {};
    this.inputElements.forEach(input => {
      data[input.name] = input.value;
      rules[input.name] = input.dataset.rules;
    });

    // Add manual password confirmation logic
    if (data.password && data.passwordConf) {
      rules.passwordConf += `|same:password`;
    }

    const validation = new Validator(data, rules);
    if (validation.fails()) {
      event.preventDefault();
      const errors = validation.errors.all();
      for (let field in errors) {
        const input = this.inputElements.find(el => el.name === field);
        if (input) input.classList.add('invalid');
        this[field].errorMessage = errors[field][0];
      }
      this.hideLoader();
      return;
    }

    // Proceed with submission
    fetch('/account/update-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.formData)
    })
    .then(response => response.json())
    .then(data => {

      console.log(data);

      if (parseInt(data, 10) === data) {
        
        this.complete = true;
        
        //window.location.replace('/dashboard?new=true');
      } else if (data.errors?.existing_user_email) {
        this.hideLoader();
        this.error = "There's already an account with this email address.";
      }
    })
    .catch(() => {
      this.message = 'Ooops! Something went wrong!';
    });
  },

  validate(event) {
    const ele = event.target;
    this[ele.name].errorMessage = '';
    this.validateField(ele.name, ele.value, ele.dataset.rules);
    if (!this[ele.name].errorMessage) {
      this.nextStage();
    }
  }
}));

Alpine.data('updateResourceHistory', () => ({
    // console.log(data.resourceID);

  /**
   * Reads data attributes directly from the clicked HTML element
   */
  handleDownloadClick(e) {

    console.log("TEST");

    // 'e.currentTarget' targets the actual <a> tag that fired the event
    const el = e.currentTarget;
    const store = Alpine.store('globalState');
    
    // Parse the Boolean flags out of string values safely
    const isLoggedIn = el.getAttribute('data-logged-in') === 'true';
    const isBundle   = el.getAttribute('data-is-bundle') === 'true';

    // 1. Map everything from data-* properties directly into globalState
    store.setResourceID(el.getAttribute('data-resource-id'));
    store.setDownloadID(el.getAttribute('data-file-id'));
    store.setResourceTitle(el.getAttribute('data-resource-title'));
    store.setResourceFile(el.getAttribute('data-file-title'));
    store.setResourceFileName(el.getAttribute('data-file-filename'));
    store.setResourceCategory(el.getAttribute('data-category-name') || 'Uncategorized');
    store.setResourceBundle(isBundle);

    // 2. Auth routing
    if (isLoggedIn) {
      this.updateResourceHistory({ 
        id: el.getAttribute('data-resource-id'), 
        title: el.getAttribute('data-file-title') 
      });
      this.trackDownload();
    } else {
      // window.accountPopUp = true; 
      this.$dispatch('trigger-auth-popup');
    }
  },

  updateResourceHistory(data){
    // console.log(data.id);
    const fileID = Alpine.store('globalState').downloadID
    // updateResourceHistory(data.id, fileID);

    if (data.id && fileID) {
      sendDownloadTelemetry(data.id, fileID);
    }

    // console.log('Download' + data.title);
    if (window.fathom) {
      fathom.trackEvent('Download: ' + data.title);
    }
  },

  trackDownload(){
    console.log("Track download");
    trackResourceDownload();
  }
}));

function sendDownloadTelemetry(resourceID, fileID) {
  // Proceed with submission using a clean payload object

  console.log(resourceID);
  console.log(fileID);

  fetch('/api/update-download-history', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      resource_id: parseInt(resourceID),
      file_id: parseInt(fileID)
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      // console.log("Telemetry logged in custom database tables successfully.");
    } else {
      console.error("Server rejected telemetry:", data.message);
    }
  })
  .catch((err) => {
    console.error('Oops! Telemetry pipeline failed:', err);
  });
}

function trackResourceDownload(){

  console.log("Tracking download");

  // GA4 datalayer push
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
      'event': 'file_download',
      'resource_id': Alpine.store('globalState').resourceID,
      'resource_title': Alpine.store('globalState').resourceTitle,
      'resource_category': Alpine.store('globalState').resourceCategory,
      'file_title': Alpine.store('globalState').resourceFile,
      'file_name': Alpine.store('globalState').resourceFileName,
      'is_bundle': Alpine.store('globalState').resourceBundle,
  });

  console.log("Download tracked");
}

Alpine.data('previewResource', (data) => ({
  nonce: data.nonce,
  previewResource: false,
  viewerInstance: null,
  container: document.getElementById('pdf-canvas'),
  previewWindow: document.getElementById('preview-window'),
  closePreview(){
    this.previewResource = false;
    if(this.viewerInstance){
      this.viewerInstance.UI.dispose(); // Cleans up the UI
      this.viewerInstance = null;
    }
    const container = document.getElementById('pdf-canvas');
    container.innerHTML = ''
  },
  openPreview(resource, type){

    if (type.toLowerCase().includes('pdf')) {
        this.previewWindow.classList.add('h-[90vh]');
        WebViewer(
          {
            path: '/app/themes/lumberjack/assets/webviewer/',
            initialDoc: resource+"?_wpnonce="+this.nonce,
            disabledElements: [
              'toolbarGroup-Annotate',
              'toolbarGroup-Insert',
              'toolbarGroup-Edit',
              'toolbarGroup-Shapes',
              'toolbarGroup-Measure',
              'toolsHeader',
              'menuButton',
              'downloadButton',
              'freeTextToolButton',
              'printButton',
              'searchButton',
              'viewControlsButton',
              'signatureToolGroupButton',
              'freeTextToolGroupButton',
              'stampToolGroupButton',
              'notesPanelButton',
              'commentsPanel',
              'notesPanel',            // the side panel that shows them
              'richTextPopup',         // comment editor
              'annotationCommentButton', // reply/comment buttons in the UI
              'activityButton',
            ],
          },
          document.getElementById('pdf-canvas')
        ).then(instance => {
          this.viewerInstance = instance;
          const { annotationManager } = instance.Core;
          instance.UI.disableElements(['ribbons']);
          instance.UI.disableElements(['toolsHeader']);
          // annotationManager.disableAnnotations();
          annotationManager.setCanModify(false);

          instance.UI.addEventListener(instance.UI.Events.DOCUMENT_LOADED, () => {
            annotationManager.setAnnotations([]); // ✅ Hides all annotations once loaded
          });
        });
    } else if (type.toLowerCase().includes('mp4')) { 
      this.previewWindow.classList.remove('h-[90vh]');
      // const container = document.getElementById('pdf-canvas');
      const video = document.createElement('video');
      video.src = resource + '?_wpnonce=' + this.nonce;
      video.controls = true;
      video.autoplay = true;
      video.muted = true; // Required for autoplay in most browsers
      video.playsInline = true;
      video.style.width = '100%'; // Optional: make it responsive
      this.container.appendChild(video);
    } else if (type.toLowerCase().includes('mp3')) {
      this.previewWindow.classList.remove('h-[90vh]');
      // const container = document.getElementById('pdf-canvas');
      const audio = document.createElement('audio');
      audio.src = resource + '?_wpnonce=' + this.nonce;
      audio.controls = true;
      audio.autoplay = true;
      this.container.appendChild(audio);
    } 

    this.previewResource = true;
  }

}));



function updateResourceHistory($resourceID){
  console.log($resourceID);
  // Proceed with submission
    fetch('/update-download-history', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify($resourceID)
    })
    .then(response => response.json())
    .then(data => {

      console.log("Added to download history");
      
    })
    .catch(() => {
      this.message = 'Ooops! Something went wrong!';
    });
}


Alpine.data('audioPlayer', (data) => ({
  title: data.title,
  id: data.id,
  isPlaying: false,
  duration: 0,
  currentTime: 0,
  progress: 0,
  player: null,
  pendingSeekTime: null,
  hasStarted: false,
  hasCompleted: false,
  // Tooltip & scrub state
  isScrubbing: false,
  hoverTime: 0,
  hoverX: 0,
  showHoverTime: false,
  progressMilestonesFired: [],

  togglePlayback() {
    if (!this.player) return;

    if (this.player.paused) {
      this.player.play();
      this.isPlaying = true;

      // Apply pending seek if needed
      if (this.pendingSeekTime !== null) {
        this.player.setCurrentTime(this.pendingSeekTime);
        this.pendingSeekTime = null;
      }

      if(!this.hasStarted){
        this.hasStarted = true;
        // Podcast Start - when a user starts a podcast
        window.dataLayer.push({
          event: "podcast_start", // CONSTANT
          podcast_title: this.title, // Replace dynamically
          podcast_id: this.id            // Optional unique identifier
        });

      }

    } else {
      this.player.pause();
      this.isPlaying = false;
    }
  },

  skip(seconds) {
    if (!this.player) return;

    const target = this.player.currentTime + seconds;
    const clamped = Math.max(0, Math.min(this.duration, target));

    if (this.player.paused) {
      this.pendingSeekTime = clamped;
    } else {
      this.player.setCurrentTime(clamped);
    }
  },

  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  },

  startScrubbing(event) {
    if (!this.player || !this.player.duration) return;
    this.isScrubbing = true;
    this.scrub(event);
  },

  scrub(event) {
    if (!this.isScrubbing || !this.player || !this.player.duration) return;

    const container = this.$el;
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const x = Math.min(Math.max(0, event.clientX - rect.left), rect.width);
    const percent = x / rect.width;
    this.progress = percent * 100;
  },

  setCurrentTime(event) {
    const container = this.$el;
    if (!container || !this.player?.duration) return;

    const rect = container.getBoundingClientRect();
    const x = Math.min(Math.max(0, event.clientX - rect.left), rect.width);
    const percent = x / rect.width;
    const newTime = this.duration * percent;

    if (this.player.paused) {
      console.log(newTime);
      this.pendingSeekTime = newTime;
      console.log(this.pendingSeekTime);
    } else {
      this.player.setCurrentTime(newTime);
    }
  },

  stopScrubbing(event) {
    if(this.isScrubbing){
      this.isScrubbing = false;
      this.setCurrentTime(event);
    }
  },

  updateHover(event) {
    const container = event.currentTarget.closest('.relative');
    if (!container || !this.player?.duration) return;

    const rect = container.getBoundingClientRect();
    const x = Math.min(Math.max(0, event.clientX - rect.left), rect.width);
    const percent = x / rect.width;

    this.hoverTime = this.duration * percent;
    this.hoverX = x;
    this.showHoverTime = true;

    if (this.isScrubbing) {
      this.scrub(event);
    }
  },

  hideHover() {
    this.showHoverTime = false;
  },



  init() {
    const el = document.getElementById('podcast-audio');

    if (el) {
      const instance = new MediaElementPlayer(el, {
        features: [], // no UI
        success: (media) => {
          this.player = media;
          this.player.pause();

          media.addEventListener('loadedmetadata', () => {
            this.duration = media.duration;
          });

        
          media.addEventListener('play', () => {
            this.isPlaying = true;
          });

          media.addEventListener('pause', () => {
            this.isPlaying = false;
          });

          media.addEventListener('timeupdate', () => {
            if (!this.isScrubbing) {
              this.currentTime = media.currentTime;
              this.progress = (media.currentTime / media.duration) * 100;

              // Track 10% increments
              const percent = Math.floor(this.progress / 10) * 10;

              if (
                percent > 0 &&
                percent < 100 &&
                !this.progressMilestonesFired.includes(percent)
              ) {
                this.progressMilestonesFired.push(percent);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "podcast_progress",
                  podcast_title: this.title,
                  podcast_id: this.id,
                  progress_percent: percent
                });
              }
            }
          });

          media.addEventListener('ended', () => {
            this.isPlaying = false;

            const percentPlayed = (this.currentTime / this.duration) * 100;

            if (!this.hasCompleted && percentPlayed >= 95) {
              this.hasCompleted = true;
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "podcast_complete",
                podcast_title: this.title,
                podcast_id: this.id
              });
            }
          });


        }
      });
    }
  }
}));

Alpine.data('resourceRatingModal', () => ({
  open: false,
  rating: 0,
  hoverRating: 0,
  userFeedback: '',
  isSubmitting: false,
  successMessage: false,
  success: false,
  errorMessage: '',

  init() {
    // Watch our global store to see if this modal should open
    this.$watch('$store.globalState.ratingModalOpen', (value) => {
      this.open = value;
      if (value) {
        // Reset modal state parameters when opened
        this.rating = 0;
        this.hoverRating = 0;
        this.successMessage = '';
        this.errorMessage = '';
      }
    });
  },

  closeModal() {
    Alpine.store('globalState').setRatingModalOpen(false);
  },

  setRating(val) {
    this.rating = val;
  },

  setHover(val) {
    this.hoverRating = val;
  },

  submitRating() {
    // No longer need the (this.rating === 0) check here because the button is locked out!
    this.isSubmitting = true;
    this.errorMessage = '';
    
    const store = Alpine.store('globalState');

    console.log(store.resourceID);
    console.log(store.downloadID);
    console.log(this.rating);

    fetch('/api/submit-resource-rating', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        resource_id: parseInt(store.resourceID),
        file_id: parseInt(store.downloadID),
        rating: parseInt(this.rating),
        feedback: this.userFeedback
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data.message);
      console.log("2221");
      if(data.success){
        this.success = true;
        console.log(data.success);
        this.successMessage = "Thanks for your feedback.";
      }
      
      
    })
  }
}));

Alpine.data('reviewChatboxEngine', () => ({
  messages: [],
  currentMessageIndex: 0,
  panelOpen: false,
  viewMode: 'list',
  
  userRating: 0,
  hoverRating: 0,
  isSubmitting: false,
  justRated: false,
  userFeedback: '',

  init() {
    this.fetchMessages();
  },

  fetchMessages() {
    fetch('/api/user-messages')
      .then(res => res.json())
      .then(data => {
        if (data.success && data.messages.length > 0) {
          this.messages = data.messages.map(m => ({
            ...m,
            is_read: !!parseInt(m.is_read),
            resource_id: parseInt(m.resource_id) || 0,
            file_id: parseInt(m.file_id) || 0
          }));
          
          const hasUnread = this.unreadCount > 0;
          
          // Grab our recorded expiration time
          const storedExpiry = localStorage.getItem('review_hub_expiry');
          const now = new Date().getTime();
          
          // If no expiry exists, OR if the current time has passed the target time, it's safe to open!
          const isCooldownOver = !storedExpiry || now > parseInt(storedExpiry);

          if (hasUnread && isCooldownOver) {
            // If they had an old expired timer, clear it cleanly out of storage
            if (storedExpiry) localStorage.removeItem('review_hub_expiry');
            
            setTimeout(() => { this.panelOpen = true; }, 1500);
          }

          this.determineInitialRouting();
        } else {
          this.messages = [];
        }
      });
  },

  determineInitialRouting() {
    if (this.messages.length === 1) {
      this.currentMessageIndex = 0;
      this.viewMode = 'detail';
      this.resetRatingInputs();
      
      if (!this.messages[0].is_read) {
        this.markAsRead(this.messages[0].id);
      }
    } else {
      this.viewMode = 'list';
    }
  },

  get unreadCount() {
    return this.messages.filter(m => !m.is_read).length;
  },

  get currentMessage() {
    return this.messages[this.currentMessageIndex] || null;
  },

  selectMessage(index) {
    this.currentMessageIndex = index;
    this.viewMode = 'detail';
    this.resetRatingInputs();
    this.markAsRead(this.messages[index].id);
  },

  resetRatingInputs() {
    this.userRating = 0;
    this.hoverRating = 0;
    this.isSubmitting = false;
    this.justRated = false;
    this.userFeedback = '';
  },

  getRatingLabel() {
    const active = this.hoverRating || this.userRating;
    const labels = { 1: 'Poor', 2: 'Fair', 3: 'Good', 4: 'Very Good', 5: 'Excellent!' };
    return labels[active] || '';
  },

  markAsRead(id) {
    const target = this.messages.find(m => m.id === id);
    if (target && !target.is_read) {
      target.is_read = true;
      
      fetch('/api/user-messages/read', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message_id: id })
      });
    }
  },

  togglePanel() {
    this.panelOpen = !this.panelOpen;
    if (!this.panelOpen) {
      this.setDismissalExpiry();
    }
  },

  submitInlineReview() {
    if (this.userRating === 0 || !this.currentMessage || this.isSubmitting) return;

    this.isSubmitting = true;

    // console.log(this.userFeedback);

    fetch('/api/submit-resource-rating', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        resource_id: parseInt(this.currentMessage.resource_id),
        file_id: parseInt(this.currentMessage.file_id),
        rating: this.userRating,
        feedback: this.userFeedback
      })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        this.justRated = true;

        setTimeout(() => {
          const processedId = this.currentMessage.id;
          
          // Slice out the completed notification row item
          this.messages = this.messages.filter(m => m.id !== processedId);
          this.justRated = false;

          console.log(data);

          if (this.messages.length === 0) {
            this.panelOpen = false;
            sessionStorage.setItem('review_hub_dismissed', 'true');
          } else {
            // 🌟 RULE 2: 3 seconds after an ACTIVE submission, ALWAYS return 
            // the layout view state to 'list' mode, even if there is only 1 item left!
            this.viewMode = 'list';
            this.resetRatingInputs();
          }
        }, 3000);

      } else {
        this.isSubmitting = false;
        alert('Could not record submission details. Please try again.');
      }
    })
    .catch(() => {
      this.isSubmitting = false;
    });
  },

  dismissMessage(id) {
    if (this.messages.length <= 1) {
      this.panelOpen = false;
      this.setDismissalExpiry();
    }

    fetch('/api/user-messages/read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message_id: id })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        this.messages = this.messages.filter(m => m.id !== id);
        
        // Apply the same conversational list override rules upon item dismissal
        if (this.messages.length === 0) {
          this.panelOpen = false;
        } else {
          this.viewMode = 'list';
        }
      }
    });
  },

  setDismissalExpiry() {
    const now = new Date();
    // Calculate 4 days in the future (4 days * 24 hrs * 60 mins * 60 secs * 1000 ms)
    const expiryTime = now.getTime() + (4 * 24 * 60 * 60 * 1000);
    
    localStorage.setItem('review_hub_expiry', expiryTime);
  }
}));


// Gravity form tracking

document.addEventListener("DOMContentLoaded", function () {

  // 

});





window.Alpine = Alpine
Alpine.start()